<template>
  <div
    class="d-flex pa-2 flex-column"
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'min-content',
    }"
  >
    <div class="d-flex pa-5 flex-column">
      <h3>Merchant Detail</h3>
      <p>Informasi detail mengenai merchant</p>
      <p>{{ data == null ? '' : data.jenis_pengajuan }}</p>
    </div>

    <div v-if="loading" class="d-flex pa-5 flex-column">
      <v-progress-linear
        top
        v-if="loading"
        :active="loading"
        :indeterminate="loading"
        color="red lighten-2"
      />
    </div>

    <v-card
      v-if="!loading"
      class="d-flex pa-2 flex-column"
      :style="{ margin: '0px 20px 40px 20px' }"
      elevation="2"
    >
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3>Data QR</h3>
        </div>
      </v-card>
      <div :style="{ padding: '20px 50px 20px 50px' }" v-if="!loading">
        <data-detail-row
          :oldValueData="false"
          :data="data"
          :label="'Jenis QR'"
          :valueData="data.qr_type"
        />
        <data-detail-row
          v-if="isApiSnap"
          :oldValueData="false"
          :data="data"
          :label="'Client Version'"
          :valueData="data.client_version"
        />
        <v-row
          style="align-items: center"
          v-show="
            data != null && (data.id_qr_type == '4' || data.id_qr_type == '5')
          "
          v-if="merchantType == 'Aggregator'"
        >
          <v-col cols="10" sm="4" />
          <v-col cols="2" sm="1" />
          <v-col cols="12" sm="7">
            <v-radio-group
              class="ma-0"
              v-model="notifSticker"
              column
              disabled
              readonly
              dense
            >
              <template v-slot:label>
                <div>
                  Apakah anda membutuhkan <strong>notif transaksi</strong> via
                  API untuk merchant sticker anda?
                </div>
              </template>
              <v-radio label="Ya" value="1" />
              <v-radio label="Tidak" value="0" />
            </v-radio-group>
          </v-col>
        </v-row>
      </div>
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
        v-if="merchantType == 'Aggregator'"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3>Data PIC</h3>
        </div>
      </v-card>
      <div
        :style="{ padding: '20px 50px 20px 50px' }"
        v-if="!loading && merchantType == 'Aggregator'"
      >
        <data-detail-row
          :oldValueData="false"
          :data="data"
          :label="'Nama PIC'"
          :valueData="data.aggre_pic_name"
        />
        <data-detail-row
          :oldValueData="false"
          :data="data"
          :label="'Nomor KTP PIC'"
          :valueData="data.aggre_pic_ktp_no"
        />
        <data-detail-row
          :oldValueData="false"
          :data="data"
          :label="'Jabatan'"
          :valueData="data.aggre_pic_jabatan"
        />
        <data-detail-row
          :oldValueData="false"
          :data="data"
          :label="'No Handphone'"
          :valueData="data.aggre_pic_mobile_phone"
        />
        <data-detail-row
          :oldValueData="false"
          :data="data"
          :label="'Email'"
          :valueData="data.aggre_pic_email"
        />
      </div>
      <v-card :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }">
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3>{{ this.headingInfo }}</h3>
        </div>
      </v-card>

      <!-- ====================== data detail -->

      <div
        :style="{ padding: '20px 50px 20px 50px' }"
        v-if="!loading && merchantType == 'Merchant'"
      >
        <!-- ====================== data detail merchant -->
        <detail-tracking-merchant :data="data" />
      </div>
      <div
        :style="{ padding: '20px 50px 20px 50px' }"
        v-if="!loading && merchantType == 'Aggregator'"
      >
        <!-- ====================== data detail agree -->
        <detail-tracking-agree :data="data" />
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {
    DataDetailRow: () => import('./DataDetailRow.vue'),
    DetailTrackingMerchant: () => import('./DetailTrackingMerchant.vue'),
    DetailTrackingAgree: () => import('./DetailTrackingAgree.vue'),
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headingInfo() {
      if (this.data == null) return '...';
      return this.data.merchant_type_id == 2
        ? 'Data Aggregator'
        : 'Info Merchant';
    },
    merchantType() {
      if (this.data != null) {
        return this.data.merchant_type_id == 2 ? 'Aggregator' : 'Merchant';
      }
      return '';
    },
    notifSticker() {
      try {
        return this.data == null
          ? ''
          : this.data.notif_sticker_status.toString();
      } catch {
        return '';
      }
    },
    isApiSnap() {
      if (this.data == null) return false;
      // eslint-disable-next-line eqeqeq
      return this.data.id_qr_type == 2 && this.data.client_version === 'SNAP';
    },
  },
};
</script>
